module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.ZoomContainerStyle),
    on: {
      "click": _vm.handleUnzoom
    }
  }, [_c('Overlay', {
    attrs: {
      "isVisible": _vm.isZoomed,
      "defaultStyle": _vm.defaultStyles.overlay
    }
  }), _vm._v(" "), _c('img', {
    class: _vm.zoomImage.className,
    style: (_vm.getZoomImageStyle()),
    attrs: {
      "alt": _vm.zoomImage.alt,
      "src": _vm.src
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/vue-loader/12.2.2/vue-loader/lib/template-compiler?{"id":"data-v-1e9615ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.npminstall/vue-loader/12.2.2/vue-loader/lib/selector.js?type=template&index=0!./src/components/Zoom.vue
// module id = 55
// module chunks = 1